const cart = () => {
  const quantity_select = document.querySelectorAll('.cart__current-quantity-wrapper');
  
  if(quantity_select != undefined) {
    for(let i=0; i < quantity_select.length; i++) {
      let addItem = quantity_select[i].querySelector('.cart__current-add');
      let lessItem = quantity_select[i].querySelector('.cart__current-less');
      let quantityItem = quantity_select[i].querySelector('.cart__current-quantity');

      addItem.addEventListener('click', () => {
        quantityItem.value++;
      });
      lessItem.addEventListener('click', () => {
        if(quantityItem.value === "0") {
          quantityItem.value = '0'
        }
        else {
          quantityItem.value--;
        }
      });
    }
  }

}

export default cart